<template>
  <div class="role-tutorial-container">
    <div class="close-container">
      <i class="pi pi-times" @click="viewTutorial('close')"></i>
    </div>
    <div class="plan-settings-modal-header-tutorial">
      <template v-if="roleInCurrentPlanForCurrentUser.title === 'Admin'">
        <h2>Let's Get Planning</h2>
        <div class="tutorial-content">
          <p>As an Admin you can configure Channels, add Calendars of Interest, turn on Budget features, enter Tags, and add and remove Team Members.</p>
          <p>You can also add and edit Initiatives and Tactics. Click below to open our tutorial in a new tab so you can follow along while you begin planning.</p>
        </div>
      </template>
      <template v-else-if="roleInCurrentPlanForCurrentUser.title === 'Contributor'">
        <h2>Let's Get Planning</h2>
        <div class="tutorial-content">
          <p>As a Contributor you can add Initiatives and Tactics to the Plan.</p>
          <p>Click below to open our tutorial in a new tab so you can follow along<br/><br/>while you begin planning.</p>
        </div>
      </template>
      <template v-else>
        <h2>Get a Good Look</h2>
        <div class="tutorial-content">
          <p>As a Viewer you can see all Initiatives and Tactics, customize your view, and filter the data.</p>
          <p>Click below to open our tutorial in a new tab so you can follow along while you review the Plan.</p>
        </div>
      </template>

      <Button @click="viewTutorial('view')" class="view-tutorial-button">View Tutorial</Button>

      <div class="access-control">
        <p>You can access this tutorial at any time by visiting Guides under Help
          in the bottom left corner of the application or when in a Plan by
          clicking on {{roleButtonText}} in the middle top of the application.</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Role from '@/models/Role'

export default Vue.extend({
  name: 'TutorialRoles',
  props: {
    isViewTutorialOverride: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {isClicked: false}
  },
  computed: {
    roleInCurrentPlanForCurrentUser(): Role {
      const thisUserRole = this.$store.getters.currentPlan.userRoles.find(
        (userRole) =>
          userRole.userId.intID == this.$store.getters.currentUser.id.intID
      )
      if (
        thisUserRole &&
        thisUserRole.roleId &&
        thisUserRole.roleId.intID != 0
      ) {
        return this.$store.getters.allRoles.find(
          (role) => role.id.intID == thisUserRole.roleId.intID
        )
      }
      return new Role()
    },
    roleButtonText(): string {
      if (
        this.$store.getters.currentAccountPermissionLevel ===
        Role.LEVEL_ACCOUNT_OWNER
      ) {
        return 'How To Guide: Account Owner'
      }
      switch(this.roleInCurrentPlanForCurrentUser.title){
        case 'Admin':
          return 'How To Guide: Admin'
        case 'Contributor':
          return 'How To Guide: Contributor'
        default:
          return 'How To Guide: Viewer'
      }
    },
    tutorialUrl(): string {
      if (
        this.$store.getters.currentAccountPermissionLevel ===
        Role.LEVEL_ACCOUNT_OWNER
      ) {
        return this.$store.getters.tutorialUrlsDict['accountOwner']
      }
      switch(this.roleInCurrentPlanForCurrentUser.title){
        case 'Admin':
          return this.$store.getters.tutorialUrlsDict['planAdmin']
        case 'Contributor':
          return this.$store.getters.tutorialUrlsDict['contributor']
        default:
          return this.$store.getters.tutorialUrlsDict['viewer']
      }
    },
  },
  methods: {
    viewTutorial(type) {
      if(this.isViewTutorialOverride){
        if(type === 'view'){
          window.open(this.tutorialUrl, '_blank')
        }else{
          this.$emit('updateViewTutorial')
        }
        return
      }

      this.$store.state.services.plans.updateVisitedPlan(
        {
          plan: this.$store.getters.currentPlan.id.apiID,
          role: this.roleInCurrentPlanForCurrentUser.id.apiID,
          user: this.$store.getters.currentUser.id.apiID
        }
      ).then(
        (response)=>{
          this.$store.getters.currentUser.rolesObserved = response.data.rolesObserved
          this.$store.getters.services.users.update(this.$store.getters.currentUser).then(
            (user)=>{
              if(type === 'view' ){
                window.open(this.tutorialUrl, '_blank')
              }
              this.$emit('updateViewTutorial')
            }
          )
        }
      )
    },
  },
})
</script>

<style lang="scss">
@import '@/styles/_imports.scss';

.role-tutorial-container {
  h2 {
    font-size: 4rem;
    font-weight: bold;
  }
  button {
    @include font-mulish-light;
    font-weight: bold;
    margin: 0 0 2rem;
  }
  .tutorial-content {
    max-width: 65rem;
    margin: 1.5rem auto 0;

    p {
      @include font-mulish-light;
      font-size: 2rem;
      font-weight: 600;
    }
  }
  .access-control {
    max-width: 40rem;
    margin: 2rem auto 6rem;

    @include font-mulish-light;
    font-size: 1.2rem;
    font-weight: 600 !important;
  }
  .close-container {
    background-color: #f9f9f9;
    text-align: right;
    padding-right: 1rem;
    padding-top: 1rem;
  }
  .view-tutorial-button {
    margin-top: 4rem;
    font-size: 1.5rem;
  }
}
</style>
